$(document).ready(function(){
if($('body').hasClass('template-product')){
 var width = $(window).width();

  if(width < 769){
    $('.pdp-wishlist.iWishAdd').insertBefore('.small-action .pro-share_main');
    $('.small-action .pdp-wishlist.iWishAdd').wrapAll('<div class="pro-wishlist"></div>');
    // $('.small-action .pdp-wishlist.iWishAdd span').hide();
  }
}



  
$(".lp-banner-inner").slick({
 slidesToShow: 1,
 infinite:true,
 slidesToScroll: 1,
  dots:true
});
  // collections and pages
  if($('body').hasClass('template-collection')){
    $(document).on('click','.read_more_text_sec .read_more_btn .more', function(){
      $(this).parents('.metafield-rich_text_field').css('display','none');
      $(this).parents('.metafield-rich_text_field').siblings('.read_more_div').css('display','block');
    });
    $(document).on('click','.read_more_text_sec .read_less_btn .less', function(){
      $(this).parents('.read_more_div').css('display','none');
      $(this).parents('.read_more_div').siblings('.metafield-rich_text_field').css('display','block');
    });
  }else{
    $(document).on('click','.read_more_text_sec .read_more_btn .more', function(){
      $(this).parents('.read_less_div').css('display','none');
      $(this).parents('.read_less_div').siblings('.read_more_div').css('display','block');
    });
    $(document).on('click','.read_more_text_sec .read_less_btn .less', function(){
      $(this).parents('.read_more_div').css('display','none');
      $(this).parents('.read_more_div').siblings('.read_less_div').css('display','block');
    });
  }
     // multiple location    
    $('.locationsMain .map-addess').each(function(i){     
        var data_latitute = $(this).attr('data-latitute');
        var data_longitute = $(this).attr('data-longitute');
        var data_address = $(this).text();
        
        var geocoder;
        var map;
      
      var divmap = 'map'+i;
      
      var address = data_address;
      function initialize() {
        geocoder = new google.maps.Geocoder();
        var latlng = new google.maps.LatLng(data_latitute, data_longitute);
        var myOptions = {
          center: latlng,
          zoom: 15,
          scrollwheel: !1,
          zoomControl: false,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
          fullscreenControlOptions: {
              position: google.maps.ControlPosition.RIGHT_CENTER
          },
          mapTypeId: google.maps.MapTypeId.ROADMAP
          //styles: mapStyles
        };
        
        map = new google.maps.Map(document.getElementById(divmap), myOptions);
        //add custom buttons for the zoom-in/zoom-out on the map
        function CustomZoomControl(controlDiv, map) {
          //grap the zoom elements from the DOM and insert them in the map 
          var controlUIzoomIn= document.getElementById('cd-zoom-in'),
              controlUIzoomOut= document.getElementById('cd-zoom-out');
          controlDiv.appendChild(controlUIzoomIn);
          controlDiv.appendChild(controlUIzoomOut);

          // Setup the click event listeners and zoom-in or out according to the clicked element
          google.maps.event.addDomListener(controlUIzoomIn, 'click', function() {
            map.setZoom(map.getZoom()+1)
          });
          google.maps.event.addDomListener(controlUIzoomOut, 'click', function() {
            map.setZoom(map.getZoom()-1)
          });
        }
        var zoomControlDiv = document.createElement('div');
        var zoomControl = new CustomZoomControl(zoomControlDiv, map);
        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlDiv);
        if (geocoder) {
          geocoder.geocode({
            'address': address
          }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
                map.setCenter(results[0].geometry.location);
                var infowindow = new google.maps.InfoWindow({
                  content: '<div class="infobox"><strong>' + address + '</strong></div>',
                  size: new google.maps.Size(150, 50)
                });
                
                var marker = new google.maps.Marker({
                  position: results[0].geometry.location,
                  map: map,
                  icon: '',
                  title: address
                });
                
                //infowindow.open(map, marker);
                google.maps.event.addListener(marker, 'click', function() {
                  infowindow.open(map, marker);
                });
              } else {
                alert("No results found");
              }
            } else {
              alert("Geocode was not successful for the following reason: " + status);
            }
            
          });
        }
        
      }
      google.maps.event.addDomListener(window, 'load', initialize);
    });

    
var mapStyles = [{
        "featureType": "all",
        "elementType": "all",
        "stylers": [{
                "hue": "#ff0000"
            },
            {
                "saturation": -100
            },
            {
                "lightness": -30
            }
        ]},
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#ffffff"
            }]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [{
                "color": "#353535"
            }]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
                "color": "#656565"
            }]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#505050"
            }]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.stroke",
            "stylers": [{
                "color": "#808080"
            }]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{
                "color": "#454545"
            }]
        }
];

    //map filter
    var sliceDiv = 1;
    $('.location-results h3').html('<span>'+$('.locationsMain .mapMain:visible').length+' RESULTS</span>');
    $('form.map_filter .action_button').click(function(e){
      e.preventDefault();
  
      $('.location-page .location-img').hide();
      $('.locationsMain .mapMain').show();
      var countries_val = $('.countries-filter').val();
      var store_val = $('.store-filter').val();
      var elements = $('.locationsMain .mapMain');
      
      if(countries_val !== ""){
        elements = elements.filter("[data-country='"+countries_val+"']");
      }
      if(store_val !== ""){
        elements = elements.filter("[data-storename='"+store_val+"']");
      }
      
      $('.locationsMain .mapMain').not(elements).hide();
      
      if($('.locationsMain .mapMain:visible').length < 1){
        $('.location-results h3').html('<span>0 RESULT</span>');
        $('.noRecord').show();
        $('#loadMore').css('display','none');
      }
      else{
        $('.locationsMain .mapMain:visible').addClass('visibleMaps');
        $('.location-results h3').html('<span>'+$('.locationsMain .mapMain:visible').length+' RESULTS</span>');
        $('.noRecord').hide();
        
//         if($('.locationsMain .mapMain:visible').length > sliceDiv){
//           $('.locationsMain .mapMain').hide();
//           $('.locationsMain .mapMain').slice(0, sliceDiv).show();
//           $('#loadMore').css('display','block');
//         }else{          
//           $('#loadMore').css('display','none');
//         }
      }
  
      return false;
    });
    
    
    
//     $('.locationsMain .mapMain').slice(0, sliceDiv).show();
    
//     $("#loadMore").on('click', function (e) {
//       e.preventDefault();
//       $(".locationsMain .mapMain.visibleMaps:hidden").slice(0, sliceDiv).slideDown('8000');
//       if ($(".locationsMain .mapMain.visibleMaps:hidden").length == 0) {
//         $("#loadMore").fadeOut('slow');
//       }
//       $('html,body').animate({
//         scrollTop: $(this).offset().top - 132
//       }, 1000);
//     });
    
    
    var countryName = '';
    jQuery.ajax({
      url: '//get.geojs.io/v1/ip/country.json',
      type: 'GET',
      dataType: 'json',
      success: function(location) {
        countryName = location.name;              
      }
    });
    
    $('.my_location').click(function(){
      if(countryName){
          var cnt = 0;
          $('.countries-filter option').each(function(){
            if($(this).val() == countryName){cnt = 1;}
          });

          if(cnt == 1){
            $('.countries-filter').val(countryName).trigger('change');
            $('form.map_filter .action_button').trigger('click');
          }
          else{
            $('.location-page .location-img, .locationsMain .mapMain').hide();
            $('.location-results h3').html('<span>0 RESULT</span>');
            $('.noRecord').show();
          }            
        }  
    });
    
    
//     $(document).on("click",".contact-left-field > select",function() {
// //     $('.contact-left-field').click(function() {
// //       $(this).toggleClass('activeClass')
//      console.log(123);
    
//     });
    
    
    
    
  AOS.init();  
     

   // same height for pro title
  (function( $ ) {
    // the sameHeight functions makes all the selected elements of the same height
    $.fn.sameHeight = function() {
        var selector = this;
        var heights = [];

        // Save the heights of every element into an array
        selector.each(function(){
            var height = $(this).height();
            heights.push(height);
        });

        // Get the biggest height
        var maxHeight = Math.max.apply(null, heights);
        // Show in the console to verify
        // console.log(heights,maxHeight);

        // Set the maxHeight to every selected element
        selector.each(function(){
            $(this).height(maxHeight);
        }); 
    };
 
 }( jQuery ));


// $(".lp-banner-inner").slick({
//  slidesToShow: 1,
//  infinite:true,
//  slidesToScroll: 1,
//   dots:true
// });
  
// collection main banner
$(".coll_side-wrapper").slick({
 slidesToShow: 1,
 infinite:true,
 slidesToScroll: 1,
 dots:true,
adaptiveHeight: true
});

// sub collection slider
//   var flkty = new Flickity( '.sub-coll-wrapper .grid', {
//   cellAlign: 'left',
//   pageDots: true,
//   freeScroll: false,
//   wrapAround: true,
//   prevNextButtons: true,
//   contain: true,
//   autoPlay: false
// });
if($('body').hasClass('template-collection')){
  $('.sub-coll-wrapper .grid').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 4,
  responsive: [
    
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }
  ]
});
}

  //arabic condition
var url = window.location.href;
  if(url.includes('/ar/')){
    var rtl = true;
    var cell_align = 'right';
    $('.cstm-sub-inner-rtl').slick({
      dots: false,
      arrows:true,
      infinite: false,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 4,
      rtl: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {                
            slidesToShow: 4,
            slidesToScroll: 4,
            rtl: true,
          }
        }
      ]
    });
  }else{
    var rtl = false;
    var cell_align = 'left';
  $('.cstm-sub-inner').slick({
    dots: false,
    arrows:true,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 4,
    rtl: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      }
    ]
  });
}

   //logo list
  var logo_length = $('.logo-bar .logo-bar__item').length;
  if(logo_length > 6){
    var prev_next = true;
  }else{
    var prev_next = false;
  }
    var flkty = new Flickity( '.logo-bar', {
      cellAlign: cell_align,
      pageDots: true,
      freeScroll: false,
      wrapAround: true,
      prevNextButtons: prev_next,
      contain: true,
      rightToLeft:rtl
    });

    // collection list slider
    var flkty = new Flickity( '.coll_list', {
      cellAlign: cell_align,
      pageDots: true,
      freeScroll: false,
      wrapAround: true,
      prevNextButtons: true,
      contain: true,
      rightToLeft:rtl
    });
    
//end arabic condition
  
// recommendations product slider 
var compl_item_length = $('.com-item-around .complete-item').length;

var flkty = new Flickity( '.com-item-around', {
  cellAlign: 'left',
  pageDots: true,
  freeScroll: false,
  wrapAround: false,
  prevNextButtons: true,
  contain: true
});  


$('.tabs-nav ul li').click(function(){

  var currentTabIndex = $(this).index();
  var tabsContainer = $(this).closest('.tabs');
  var tabsNav = $(tabsContainer).children('.tabs-nav').children('ul').children('li');
  var tabsContent = $(tabsContainer).children('.tabs-content').children('div');
  
  var currentTablink = $(this).attr('data-link');
  var tabsContentlink = $(tabsContainer).children('.tabs-content').children('div[data-link='+currentTablink+']');
  
  $(tabsNav).removeClass('is-active');
  $(this).addClass('is-active');
  
  $(tabsContent).removeClass('is-active');
  $(tabsContentlink).addClass('is-active');
  // $(tabsContent).eq(currentTabIndex).addClass('is-active');
  
});

$('.cstm-drawer-menu .cstm-category li').on('click', function(){
  var main_sub_link = $('.cstm-category').parent('.tabs-nav').siblings('.tabs-content').find('.is-active .tabs-nav li.is-active').attr('data-link');
  console.log(main_sub_link);
  $('.main_links.is-active .sub_links').removeClass('is-active');
  $('.main_links.is-active .sub_links[data-link='+main_sub_link+']').addClass('is-active');
});
  

  //account page
if($('body').hasClass('template-customers-account')){
   var url = $(location).attr('href');
  if(url.includes('?view=order')){
    $('.ac-details-main').css('display','none');
    $('#cust_orders').css('display','block');
    $('.ac-item-list ul li.cust_orders').addClass('active');
  }
  if(url.includes('?view=returns')){
    $('.ac-details-main').css('display','none');
    $('#cust_returns').css('display','block');
    $('.ac-item-list ul li.cust_returns').addClass('active');
  }
  $(document).on('click','.ac-item-list ul li', function(){
    console.log('if');
    if($(this).hasClass('cust_orders')){
      $('.ac-item-list ul li').removeClass('active');
      $('.ac-details-main').css('display','none');
      $(this).addClass('active');
      $('#cust_orders').css('display','block');
    }else if($(this).hasClass('cust_returns')){
      $('.ac-item-list ul li').removeClass('active');
      $('.ac-details-main').css('display','none');
      $(this).addClass('active');
      $('#cust_returns').css('display','block');
    }else{
      var url = $(this).find('a').attr('href');
      console.log(url);
      window.location.href = url;
    }
  });
  // $(document).on('click','.ac-item-list .ac-name', function(){
  //   $('.ac-details-main').css('display','none');
  //   $('#account_name').css('display','block');
  // });
}else{
  $(document).on('click','.ac-item-list ul li', function(){
      var url = $(this).find('a').attr('href');
      console.log(url);
    if($(this).hasClass('cust_orders')){
      window.location.href = url + '?view=order';
    }else if($(this).hasClass('cust_returns')){
      window.location.href = url + '?view=returns';
    }else{
      window.location.href = url + '?view=order';}
  });
}
//cart page
if($('body').hasClass('template-cart')){
  var isALARendered;
  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA()
    }, 200);
  }
  ALAcheck();
  function customALA() {
    var selector = $('.recently-view-wrapper .grid.grid--uniform .grid__item');
    if(selector.length > 0) {
      clearInterval(isALARendered);
      var flkty = new Flickity( '.recently-view-wrapper .grid.grid--uniform', {
        cellAlign: 'left',
        pageDots: false,
        freeScroll: false,
        wrapAround: true,
        prevNextButtons: true,
        contain: true
      });
    }  
  }
  
}
// product page recommendations product slider
if($('body').hasClass('template-product')){
  var isALARendered;
  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA()
    }, 200);
  }
  ALAcheck();
  function customALA() {
    var selector = $('.product-recommendations-placeholder .product-recommendations');
    if(selector.length > 0) {
      clearInterval(isALARendered);
      var flkty = new Flickity( '.product-recommendations .grid', {
        cellAlign: 'left',
        pageDots: false,
        freeScroll: false,
        wrapAround: true,
        prevNextButtons: true,
        contain: true
      });
    }  
  }

  // var checked_length = $(document).find('.complete-item-wrapper input[type="checkbox"]:checked').length;
  //   if(checked_length < 1){
  //    $(document).find('.complete-item-wrapper .complete-btn a').attr('disabled',true);
  //    $(document).find('.complete-item-wrapper .complete-btn a').css('opacity','.3');
  //   }else{
  //    $(document).find('.complete-item-wrapper .complete-btn a').attr('disabled',false);
  //    $(document).find('.complete-item-wrapper .complete-btn a').css('opacity','1');
  //   }
  //  $(document).find('.complete-item-wrapper .complete-item').each(function(){
  //    $(this).find('.custom-check input[type="checkbox"]').on('change', function(){
  //      var checked_length = $(document).find('.complete-item-wrapper input[type="checkbox"]:checked').length;
  //       console.log(checked_length);
  //      if(checked_length < 1){
  //        $(document).find('.complete-item-wrapper .complete-btn a').attr('disabled',true);
  //        $(document).find('.complete-item-wrapper .complete-btn a').css('opacity','.3');
  //      }else{
  //        $(document).find('.complete-item-wrapper .complete-btn a').attr('disabled',false);
  //        $(document).find('.complete-item-wrapper .complete-btn a').css('opacity','1');
  //      }
  //    });
  //  });



  // $(document).on('click','.sticky-cart.is-show .dropdown .dropdown-menu ul li',function(){
  //   var variant = $(this).attr('data-variant');
  //   $(document).find('.variant-wrapper .variant-input-wrap .variant-input[data-variant='+variant+']').trigger('click');
  // });
  $(document).on('click','.sticky-cart.is-show .mobile_sticky_add',function(){
    if(!$(this).hasClass('sold_out')){
      $('.product-single__form .add-to-cart').trigger('click');
    }
  });
  
  setTimeout(function() {
  if($('.product-single__form .add-to-cart').attr('disabled')){
    console.log('hh');
    var btn_text = $('.product-single__form .add-to-cart span[data-add-to-cart-text]').text();
    $('.sticky-cart .mobile_sticky_add').text(btn_text).addClass('sold_out').attr('disabled',true);
  }else{
    var btn_text = $('.product-single__form .add-to-cart span[data-add-to-cart-text]').text();
    $('.sticky-cart .mobile_sticky_add').text(btn_text).removeClass('sold_out').attr('disabled',false);
  }
  }, 100);

  //variant click
  $(document).on('click','.variant-wrapper .variant-input-wrap .variant-input label',function(){
    var variant = $(this).parents('.variant-input').attr('data-variant');
    $('.sticky-cart .dropdown .dropdown-menu ul li').removeClass('selected');
    $('.sticky-cart .dropdown .dropdown-menu ul li[data-variant='+variant+']').addClass('selected');

    /*-- COMMENT BY UK --*/
    $('.sticky-cart .dropdown .dropdown-menu ul li[data-variant='+variant+']').parents('.dropdown').find('.select span').text($('.sticky-cart .dropdown .dropdown-menu ul li[data-variant='+variant+']').attr('data-value'));

    setTimeout(function() {
      if($('.product-single__form .add-to-cart').hasClass('disabled')){
        var btn_text = $('.product-single__form .add-to-cart span[data-add-to-cart-text]').text();
        $('.sticky-cart .mobile_sticky_add').text(btn_text).addClass('sold_out').attr('disabled',true);
      }else{
        var btn_text = $('.product-single__form .add-to-cart span[data-add-to-cart-text]').text();
        $('.sticky-cart .mobile_sticky_add').text(btn_text).removeClass('sold_out').attr('disabled',false);
      }
    }, 100);
  });

  var variant = $(document).find('.variant-wrapper .variant-input-wrap .variant-input input[type=radio]:checked').attr('data-variant');
  $('.sticky-cart .dropdown .dropdown-menu ul li').removeClass('selected');
  $('.sticky-cart .dropdown .dropdown-menu ul li[data-variant='+variant+']').addClass('selected');
  // $('.sticky-cart .dropdown .dropdown-menu ul li[data-variant='+variant+']').parents('.dropdown').find('span').text($('.sticky-cart .dropdown .dropdown-menu ul li[data-variant='+variant+']').attr('data-value'));

   $(document).on('click','.dropdown .dropdown-menu .drop-sizes p',function(){
     $('.tool-tip-trigger[data-tool-tip="size-chart"]').trigger('click');
   });
}

$(document).on('click','.fix_footer ul li a.nav_drawer',function(){
  console.log('jjj');
  // $('.fix_footer ul li a').removeClass('active');
  // $(this).addClass('active');

  setTimeout(function() {
  $('.js-drawer-open-nav[aria-expanded="false"]').click();
    }, 200);
  // document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true}));
    // $(document).find('.header-sticky-wrapper .header-item--navigation button.js-drawer-open-nav').attr('aria-expanded','true');
  // $('#NavDrawer').addClass('drawer--is-open');
  // $('html').addClass('js-drawer-open lock-scroll');
  // $('.fix_footer .a.js-drawer-open-cart').addClass('active');   
});

  //search page
  if($('body').hasClass('template-search')){
    $(document).on('click','.collection-grid__wrapper .collection-filter__item .custom-filter-main .cstm-filter_btn',function(){
      $(this).toggleClass('open');
      $(this).next().slideToggle();
    });

    $(document).on('click','.mobile-filter-main.desk-hide li.mobile-filter',function(){
      setTimeout(function() {
      $('.mobile-filter-main.desk-hide ul li.boost_mobile_filter_btn').find('button').trigger('click');
      // $('.collection-grid__wrapper .collection-filter button.js-drawer-open-collection-filters').trigger('click');
      }, 200);
    });
  }
  //collection page
if($('body').hasClass('template-collection')){
  if($('.sub-coll-wrapper').length > 0){
    $('.coll-breadcrumb-main').css('display','none');
  }else{
    $('.coll-breadcrumb-main').css('display','block');
  }
  //load more
  console.log("hiiie");
  $(document).on('click','.js-load-more', function(){
    var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');
    $this.find('[load-more-text]').addClass('hide');
    currentPage = currentPage+1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.grid.collection_grid').append($(responseHTML).find('.grid.collection_grid').html());
      },
      complete: function() {
        if(currentPage <= totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
         // $(document).find('.collection-grid__wrapper .grid-product__title').sameHeight();
          if(currentPage == totalPages){
            $this.hide();
          }
        }
      }
    })
  });
  
  $(document).on('click','.collection-grid__wrapper .collection-filter__item .custom-filter-main .cstm-filter_btn',function(){
    $(this).toggleClass('open');
    $(this).next().slideToggle();
  });

  $(document).on('click','.collection-content .grid__item .collection-filter__item .custom-filter-main .cstm-filter_btn',function(){
    $(this).toggleClass('open');
    $('.collection-content .grid__item.grid__item--sidebar').toggle();
    if($(this).hasClass('open')){
      $('.collection-content .grid__item.grid__item--content').removeClass('medium-up--three-quarters');
      $('.grid__item.grid-product').addClass('medium-up--one-quarter');
      $('.grid__item.grid-product').removeClass('medium-up--one-third');
    }else{
      $('.collection-content .grid__item.grid__item--content').addClass('medium-up--three-quarters');
      $('.grid__item.grid-product').removeClass('medium-up--one-quarter');
      $('.grid__item.grid-product').addClass('medium-up--one-third');
    }
  });

  // $(document).on('click','.cstm-filter_btn',function(){
  //   $(this).toggleClass('open');
  //   $('.search-content .grid__item.grid__item--sidebar').toggle();
  //   if($(this).hasClass('open')){
  //     $('.search-content .grid__item.grid__item--content').removeClass('medium-up--three-quarters');
  //     $('.grid__item.grid-product').addClass('medium-up--one-quarter');
  //     $('.grid__item.grid-product').removeClass('medium-up--one-third');
  //   }else{
  //     $('.search-content .grid__item.grid__item--content').addClass('medium-up--three-quarters');
  //     $('.grid__item.grid-product').removeClass('medium-up--one-quarter');
  //     $('.grid__item.grid-product').addClass('medium-up--one-third');
  //   }
  // });

  var width = $(window).width();
  if(width < 960){
    // var html = $('#CollectionSidebar').html();
    // var pro_html = '<div class="grid__item medium-up--one-fifth grid__item--sidebar"><div id="CollectionSidebar" data-style="sidebar">'+ html + '</div></div>';
    // $('#CollectionSidebar').insertBefore('.grid__item--content');
    // $('#CollectionSidebar').wrapAll('<div class="grid__item medium-up--one-fifth grid__item--sidebar"/>');
  }else{
    // $('#CollectionSidebar').insertAfter('.custom-filter-main .grid__item--sidebar .coll-filter-title');
    
  }

  $(window).on('resize', function(){
    var width = $(window).width(); //this = window
    // if (win.height() >= 820) { /* ... */ }
    if (width < 769) { 
       // $('#CollectionSidebar').insertBefore('.grid__item--content');
       // $('#CollectionSidebar').wrapAll('<div class="grid__item medium-up--one-fifth grid__item--sidebar"/>');
      // $('.grid__item.medium-up--one-fifth.grid__item--sidebar').each(function(){
      //   var length = $(this).children().length;
      //   // console.log(length);
      //   if(length < 1){
      //     $(this).remove();
      //   }
      // });
        $('.collection-content .grid__item.grid__item--content').removeClass('medium-up--three-quarters');
        $('.search-content .grid__item.grid__item--content').removeClass('medium-up--three-quarters');
        $('.grid__item.grid-product').addClass('medium-up--one-quarter');
        $('.grid__item.grid-product').removeClass('medium-up--one-third');
    }else{
       // $('#CollectionSidebar').insertAfter('.custom-filter-main .grid__item--sidebar .coll-filter-title');
       // $('.grid__item.medium-up--one-fifth.grid__item--sidebar').remove();
          if($('.collection-content .grid__item .collection-filter__item .custom-filter-main .cstm-filter_btn').hasClass('open')){
            $('.collection-content .grid__item.grid__item--content').removeClass('medium-up--three-quarters');
            $('.grid__item.grid-product').addClass('medium-up--one-quarter');
            $('.grid__item.grid-product').removeClass('medium-up--one-third');
          }else{
            $('.collection-content .grid__item.grid__item--content').addClass('medium-up--three-quarters');
            $('.grid__item.grid-product').removeClass('medium-up--one-quarter');
            $('.grid__item.grid-product').addClass('medium-up--one-third');
          }
        
          if($('.search-content .grid__item .collection-filter__item .custom-filter-main .cstm-filter_btn').hasClass('open')){
            $('.search-content .grid__item.grid__item--content').removeClass('medium-up--three-quarters');
            $('.grid__item.grid-product').addClass('medium-up--one-quarter');
            $('.grid__item.grid-product').removeClass('medium-up--one-third');
          }else{
            $('.search-content .grid__item.grid__item--content').addClass('medium-up--three-quarters');
            $('.grid__item.grid-product').removeClass('medium-up--one-quarter');
            $('.grid__item.grid-product').addClass('medium-up--one-third');
          }
    }
  });

  $(document).on('click','.mobile-filter-main.desk-hide li.mobile-filter',function(){
    setTimeout(function() {
    var filter_drawer = $('.fix_footer').height();
    $('#FilterDrawer').css('bottom',filter_drawer+'px');  
    $('.mobile-filter-main.desk-hide ul li.boost_mobile_filter_btn').find('button').trigger('click');
    // $('.collection-grid__wrapper .collection-filter button.js-drawer-open-collection-filters').trigger('click');
    }, 200);
  });
  // $('.mobile-filter.desk-hide li.mobile-filter').on('click', function(){
  //   setTimeout(function() {
  //   $('.collection-grid__wrapper .collection-filter button.js-drawer-open-collection-filters').trigger('click');
  //   }, 200);
  // });

}
 
    

  
$(".search_wrapp input").focus(function(){
   $('.sticky-search').toggleClass("open");
    $('body').toggleClass("search-open");
});

// header height count
var header_height = $('.shopify-section-group-header-group').height();
$('#NavDrawer').css('top',header_height+'px');

// sticky cart height count on product page
var fix_footer_height = $('.fix_footer').height();
$('.sticky-cart').css('bottom',fix_footer_height+'px');  

// mobile sort option on collection page
var mobile_sort = $('.fix_footer').height();
// $('.mobile-sort-dropdown').css('bottom',mobile_sort+'px');    

$(document).on('click','.mobile-filter-main.desk-hide li.mobile-sort',function(){
  var mobile_sort = $('.fix_footer').height();
  $('.mobile-sort-dropdown').css('bottom',mobile_sort+'px'); 
  $('.mobile-sort-dropdown').addClass('is-open');
  $('body').addClass('open');
});
$(document).on('click','.mobile-sort-dropdown.desk-hide.is-open .sort-title .close',function(){
    $('.mobile-sort-dropdown').removeClass('is-open');
    $('body').removeClass('open');
});

//mobile sort functionality
$(document).on('click','.mobile-sort-dropdown.desk-hide.is-open ul li',function(){
  var value = $(this).attr('value');
  document.querySelectorAll("a[data-sort="+value+"]").forEach(el=>el.click())
  $(this).siblings('li').removeClass('selected');
  $(this).addClass('selected');
  $('.mobile-sort-dropdown .sort-title .close').trigger('click');
    // var sortBySelect = document.querySelector("select#SortBy"); 
    // sortBySelect.value = value; 
    // sortBySelect.dispatchEvent(new Event("change"));
});
  
$('ul.tabs li').click(function(){
  var tab_id = $(this).attr('data-tab');

  $('ul.tabs li').removeClass('current');
  $('.tab-content').removeClass('current');

  $(this).addClass('current');
  $("#"+tab_id).addClass('current');
})
// sticky  cart select box

  if($('body').hasClass('template-product')){
       $(document).on('click','.dropdown .select',function(e){
    var width = $(window).width();
    if(width < 769){
      if(!$('body').hasClass('page--faqs')){
       $('body').toggleClass('open');
      }
    }
      $(this).parent('.dropdown').attr('tabindex', 1).focus();
      $(this).parent('.dropdown').toggleClass('active');
      $(this).parent('.dropdown').find('.dropdown-menu').slideToggle(300);
   });
  }else{
  $(document).on('click','.dropdown',function(e){
    var width = $(window).width();
    if(width < 769){
      if(!$('body').hasClass('page--faqs')){
       $('body').toggleClass('open');
      }
    }
      $(this).attr('tabindex', 1).focus();
      $(this).toggleClass('active');
      $(this).find('.dropdown-menu').slideToggle(300);
    //  console.log(e.target);
    //  var container = document.querySelector('.sizes');
    // if (container.contains(e.target)) {
    //   console.log('yes sizes');
      
    // }else{
    //     console.log('yes');
    //    $(this).attr('tabindex', 1).focus();
    //   $(this).toggleClass('active');
    //   $(this).find('.dropdown-menu').slideToggle(300); 
    // }
    
    // console.log($(e.target).closest('.optionflex'));
    // if($(e.target).closest('.optionflex .sizeoption').length){
    //   $('body').addClass('open');
    //   // $(this).attr('tabindex', 1).focus();
    //   // $(this).toggleClass('active');
    //   // $(this).find('.dropdown-menu').slideToggle(300); 
    // } else {
    //   $(this).attr('tabindex', 1).focus();
    //   $(this).toggleClass('active');
    //   $(this).find('.dropdown-menu').slideToggle(300); 
    // }
  });
}
  $('.dropdown').focusout(function () {
      $('body').removeClass('open');
      $(this).removeClass('active');
      $(this).find('.dropdown-menu').slideUp(300);
  });
  
  $(document).on('click','.dropdown .dropdown-menu li',function(){
  // $('.dropdown .dropdown-menu li').click(function () {

    if($('body').hasClass('template-product')){
     if(!$(this).hasClass('sizes')){
       $(this).parents('.dropdown').find('span').text($(this).text());
       $(this).parents('.dropdown').find('input').attr('value', $(this).attr('id'));
     }
    }else{
      $(this).parents('.dropdown').find('span').text($(this).text());
      $(this).parents('.dropdown').find('input').attr('value', $(this).attr('id'));
    }
      

    if($('body').hasClass('template-collection')){
    var value = $(this).attr('value');
      document.querySelectorAll("a[data-sort="+value+"]").forEach(el=>el.click())
      $(this).siblings('li').removeClass('selected');
      $(this).addClass('selected');
    // var sortBySelect = document.querySelector("select#SortBy"); 
    // sortBySelect.value = value; 
    // sortBySelect.dispatchEvent(new Event("change"));
    }
    if($('body').hasClass('page--faqs')){
      var value = $(this).attr('value');
      $('.faq_sort_option .dropdown .dropdown-menu li').removeClass('selected');
      $(this).addClass('selected');
      if(value == 'all'){
         $('.question_type').parent().css('display','block');
      }else{
        $('.question_type').each(function(){
          if($(this).hasClass(value)){
            $(this).parent().css('display','block');
          }else{
            $(this).parent().css('display','none');
          }
        });
      }
    }
    if($('body').hasClass('template-search')){
    var value = $(this).attr('value');
      document.querySelectorAll("a[data-sort="+value+"]").forEach(el=>el.click())
      $(this).siblings('li').removeClass('selected');
      $(this).addClass('selected');
    // var sortBySelect = document.querySelector("select#SortBy"); 
    // sortBySelect.value = value; 
    // sortBySelect.dispatchEvent(new Event("change"));
    }
    if($('body').hasClass('template-product')){
      // var value = $(this).attr('data-value');
      // $(this).parents('.dropdown').find('span').text(value);
      // console.log(vvv);
      $(this).parents('ul').find('li').removeClass('selected');
      $(this).addClass('selected');
      var variant = $(this).attr('data-variant');
      $(document).find('.variant-wrapper .variant-input-wrap .variant-input[data-variant='+variant+'] label').trigger('click');
      // $(document).find('.variant-wrapper .variant-input-wrap .variant-input[data-variant='+variant+']').trigger('click');
      if(!$(this).hasClass('sizes')){
      setTimeout(function() {
        if($('.product-single__form .add-to-cart').hasClass('disabled')){
          var btn_text = $('.product-single__form .add-to-cart span[data-add-to-cart-text]').text();
          $('.sticky-cart .mobile_sticky_add').text(btn_text).addClass('sold_out').attr('disabled',true);
        }else{
          var btn_text = $('.product-single__form .add-to-cart span[data-add-to-cart-text]').text();
          $('.sticky-cart .mobile_sticky_add').text(btn_text).removeClass('sold_out').attr('disabled',false);
          $('.sticky-cart .mobile_sticky_add').trigger('click');
        }
      }, 100);
      }
    }
  });    

  if($('body').hasClass('template-product')){
  // ask us popup product page
var modal = document.querySelector(".cstm-modal");
var trigger = document.querySelector(".ask_us.trigger");
var closeButton = document.querySelector(".close-button");

function toggleModal() {
    document.querySelector('body').classList.toggle('open-ask-modal');
    modal.classList.toggle("show-modal");
}

function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
}

trigger.addEventListener("click", toggleModal);
closeButton.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);

// share popup product page
var share_modal = document.querySelector(".cstm-modal.for_share");
var share_trigger = document.querySelector(".pro_share.trigger");
var share_closeButton = document.querySelector(".for_share .close-button");

function toggleModalshare() {
    document.querySelector('body').classList.toggle('open-ask-modal');
    share_modal.classList.toggle("show-modal");
}

function windowOnClickshare(event) {
    if (event.target === modal) {
        toggleModalshare();
    }
}
share_trigger.addEventListener("click", toggleModalshare);
share_closeButton.addEventListener("click", toggleModalshare);
window.addEventListener("click", windowOnClickshare);

if($('body').hasClass('template-product')){
  if($('.complete-item-wrapper').length > 0){
// complete the look
var share_modal_complete = document.querySelector(".cstm-modal.for_complete");
var share_trigger_complete = document.querySelector(".complete_look_cta.trigger");
var share_closeButton = document.querySelector(".for_complete .close-button");

function toggleModalsharecomplete() {
  $('.cstm-modal.for_complete .complete__item').css('display','flex');
    document.querySelector('body').classList.toggle('open-ask-modal');
    share_modal_complete.classList.toggle("show-modal");
}

function windowOnClicksharecomplete(event) {
    if (event.target === modal) {
        toggleModalshare();
    }
}
share_trigger_complete.addEventListener("click", toggleModalsharecomplete);
share_closeButton.addEventListener("click", toggleModalsharecomplete);
window.addEventListener("click", windowOnClicksharecomplete);
  }
}
  

$('.product-block .pro_share.trigger').on('click', function(){
  $('.product-top .pro_share.trigger').trigger('click');
});
$('.product-block .ask_us.trigger').on('click', function(){
  $('.product-top .ask_us.trigger').trigger('click');
});
    
}


$(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('.sticky-cart').addClass('is-show');
    } else {
       $('.sticky-cart').removeClass('is-show');
    }
});

// $('.pro_share').on('click', function() {
//   $('.social-sharing').slideToggle();
// });  

  
//country popup first time load
    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    }

    function setCookie(name,value,days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  
    var countryName = '';
    jQuery.ajax({
      url: '//get.geojs.io/v1/ip/country.json',
      type: 'GET',
      dataType: 'json',
      success: function(location) {
        countryName = location.name; 

        console.log(countryName);
        //United Arab Emirates
        if(countryName != 'United Arab Emirates'){
          var myCookie = getCookie('lang_country_popup');
          if (myCookie == null) {
            if (Shopify.designMode) {
            // This will only render in the theme editor
            console.log("YES");
            } else {
             $('.cstm-modal.lang_country_popup').css({'visibility':'visible','opacity':'1'});
            }
          }

          //country
        $(document).on('click','.cstm-modal.lang_country_popup .lang-item.countries .cstm-con',function(){
           $(this).find('.counrty-list').toggle();
        });
        $(document).on('click','.cstm-modal.lang_country_popup .lang-item.countries .cstm-con ul li',function(){
           var text = $(this).attr('data-text');
           var img_src = $(this).find('img').attr('src');
           $('.cstm-modal.lang_country_popup .lang-item.countries .cstm-con h4').html('<img src="'+img_src+'" alt="image" />'+text);
        });

         //languages
         // $(document).on('change','.cstm-modal.lang_country_popup .lang-item.languages select',function(){
         //   var value = $(this).val();
         //   const container = document.querySelector(".disclosure-list__option[data-value="+value+"]");
         //   container.click();
         //   setCookie('lang_country_popup','Yes');
         // });
         // $(document).on('click','.cstm-modal.lang_country_popup .lang-item.languages select',function(){
         //   var value = $(this).val();
         //   console.log(value);
         //   if(value == 'en'){
         //     const container = document.querySelector(".disclosure-list__option[data-value="+value+"]");
         //     container.click();
         //     setCookie('lang_country_popup','Yes');
         //   }
         // });
         $(document).on('click','.cstm-modal.lang_country_popup a.btn',function(){
           var value = $('.cstm-modal.lang_country_popup .lang-item.languages select').val();
           const container = document.querySelector(".disclosure-list__option[data-value="+value+"]");
           container.click();
           setCookie('lang_country_popup','Yes');
         });
         $(document).on('click','.cstm-modal.lang_country_popup .cstm-lang-close', function(){
           $('.cstm-modal.lang_country_popup').css({'visibility':'hidden','opacity':'0'});
           setCookie('lang_country_popup','Yes');
         });
        }
      }
    });


  //complete the look popup.
  $(document).on('click','.cstm-modal.for_complete .back-pdp', function(){
    $('.cstm-modal.for_complete').find('span.close-button').trigger('click');
  });
  $(document).on('click','.cstm-modal.for_complete .comp-remove a,.cstm-modal.for_complete .comp-small-remove a', function(){
    $(this).parents('.complete__item').css('display','none');
    var length = $('.complete__item:visible').length;
    if(length == 0){$('.cstm-modal.for_complete').find('span.close-button').trigger('click');}
  });
  $(document).on('change','.cstm-modal.for_complete .comp-variant select', function(){
    var price = parseInt($(this).find('option:selected').attr('data-price'));
    var compare_price = parseInt($(this).find('option:selected').attr('data-compare-price'));
    $(this).parents('.comp-detail-inner').find('.price_discount .product_price_div .product__price').html(theme.Currency.formatMoney(price, theme.settings.moneyFormat));    
    if(compare_price > 0){
      $(this).parents('.comp-detail-inner').find('.price_discount .product_price_div .product__price--compare').html(theme.Currency.formatMoney(compare_price, theme.settings.moneyFormat));
      $(this).parents('.comp-detail-inner').find('.price_discount .product_price_div .product__price--compare').removeClass('hide');
    }
  });
  $(document).on('click','.cstm-modal.for_complete .js-qty__adjust', function(){
    var qty = parseInt($(this).parents('.complete__item.in_stock').find('.popup_product_qty').val());
    if($(this).hasClass('js-qty__adjust--plus')){
      var new_qty = qty + 1;
      $(this).parents('.complete__item.in_stock').find('.popup_product_qty').val(new_qty);
    }else{
      if(qty > 1){
        var new_qty = qty - 1;
        $(this).parents('.complete__item.in_stock').find('.popup_product_qty').val(new_qty);
      }
    }
  });
  $(document).find('.cstm-modal.for_complete .complete-tabel .com-add-cart a.popup_add_to_cart').click(function(){
    $(this).addClass('btn--loading');
    if($('.complete__item.in_stock').filter(':visible').length > 0){
      var arrPdp = [];
      var totalLi = $('.complete__item').length;
      var ll = $('.complete__item.in_stock').filter(':visible').length;
        console.log(ll);
      
      $(".complete__item").each(function(index) {
        if($(this).hasClass('already_cart')){
          var var_id = $(this).attr('data-pro-id');
              var data = 'id='+ var_id + '&quantity='+0;
          jQuery.post('/cart/change.js', {quantity: 0, id: var_id});
          document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true}));
        }
        if($(this).hasClass('in_stock')){
          if($(this).is(':visible')){
            var var_id = $(this).find('.comp-variant select').val();
            var var_qty = $(this).find('.popup_product_qty').val();
            arrPdp.push({'var_id':var_id,'qty':var_qty});
            // arrPdp.push({id: var_id, quantity: var_qty});
          }
        }
       
        if (index === totalLi - 1) {
          if(arrPdp.length > 0){
            setTimeout(function() {
            moveAlong(arrPdp);
            }, 1500);
          }
        }
      });
    }
  });
    function moveAlong(toAdd){
      if (toAdd.length) {
        var request = toAdd.shift();
        var tempId= request.var_id;
        var tempQty = request.qty;
        var data = 'id='+ tempId + '&quantity='+tempQty;
        console.log(data);
        var params = {
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function(line_item) {
            moveAlong(toAdd);
          },
          error: function(error) {
            moveAlong(toAdd);
          }
        };
        $.ajax(params);
      } else {
        $('.cstm-modal.for_complete .complete-tabel .com-add-cart a.popup_add_to_cart').removeClass('btn--loading');
        $('.cstm-modal.for_complete').find('span.close-button').trigger('click');
        document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true}));
        var cartDrawerButtonSelector = "a.js-drawer-open-cart";
        var cartDrawerButton = document.querySelector(cartDrawerButtonSelector);
        setTimeout(function() {
        cartDrawerButton.click();
        jQuery.getJSON('/cart.js', function(cart) {
          $(document).find('.cart-link__bubble--visible').text(cart.item_count);
        });
        }, 500);
      }      
    }


  //product page default variant select error
  $(document).on('click','.product-single__form button.add-to-cart', function(){
    if($(this).hasClass('select_size_first')){
      $('.size_select_error_msg').css('display','block');
      $('.sticky-cart.is-show .dropdown').trigger('click');
      return false;
    }else{
      var var_id = $('[name="id"]').val();
      $('.cstm-modal.for_complete .complete__item.same_product').addClass('already_cart');
      $('.cstm-modal.for_complete .complete__item.same_product').attr('data-pro-id',var_id);
      var html = '<div class="already_add_msg">Already In Cart</div>';
      if($('.cstm-modal.for_complete .complete__item.same_product .already_add_msg').length < 1){
      $(html).insertAfter('.cstm-modal.for_complete .complete__item.same_product .comp-variant.more_variant');
      }
      $('.cstm-modal.for_complete .complete__item.same_product .comp-remove').hide();
      $('.cstm-modal.for_complete .complete__item.same_product .comp-small-remove').hide();
      return true;
    }
  });
  $(document).on('click','#CartDrawer .js-qty__adjust', function(){
    if($('body').hasClass('template-product')){
      console.log('hh')   
      var product_id = $('.product-section').attr('data-product-id');
      setTimeout(function() {
       jQuery.getJSON('/cart.js', function(cart) {
          let cartData = cart.items;
          if(cartData.length > 0){
            var product_true = false;
              for(var i=0;i<cartData.length;i++){
                if(cartData[i].product_id == product_id){
                  console.log('hh');
                  var product_true = true;
                  break;
                }
              }
            console.log(product_true);
          }else{
              $('.cstm-modal.for_complete .complete__item.same_product').removeClass('already_cart');
              $('.cstm-modal.for_complete .complete__item.same_product').attr('data-pro-id','');              
              $('.cstm-modal.for_complete .complete__item.same_product .already_add_msg').remove();
              $('.cstm-modal.for_complete .complete__item.same_product .comp-remove').show();
              $('.cstm-modal.for_complete .complete__item.same_product .comp-small-remove').show();
          }
          // if(cartData.length > 0){
          //   document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
          //   document.dispatchEvent(new CustomEvent('cart:refresh', {
          //     bubbles: true,
          //     detail: cartData
          //   }));  
            
          // }
        });
      }, 2000);
    }
   
  });
  $(document).on('click','.product-block[data-dynamic-variants-enabled] fieldset.size_options label', function(){
    $('.size_select_error_msg').css('display','none');
    $('.product-single__form button.add-to-cart').removeClass('select_size_first');
  });
});

// brand accordian

// $('.acc-container .acc:nth-child(1) .acc-head').addClass('active');
// $('.acc-container .acc:nth-child(1) .acc-content').slideDown();
$('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
});  

// mobile sort option on collection page
var brand_filter = $('.fix_footer').height() + 10;
  $('.mob-brand-btn').css('bottom',brand_filter+'px');    

function openNav() {
    document.getElementById("mySidenav").style.width = "300px";
}

function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
}

//brand page filter code
$(".acc-container").find(".acc").each(function(){
  $(this).find(".acc-head").click(function(){
  var getBrandTitle = $(this).attr("data-brand-title");
    // console.log("getBrandTitle",getBrandTitle);
    $(".brand-logos ul").find("li").each(function(){
       var getFilterValue = $(this).attr("data_filter_value");
      if (getBrandTitle == getFilterValue) {
        $(this).show();
      }else{
        $(this).hide();
      }
    });
    if($(this).hasClass('active')) {
      $(".clear_filter").show();
    }else{
     $(".brand-logos ul").find("li").show();
    $(".clear_filter").hide();
    }
  });
  $(".clear_filter").click(function(){
    $(".acc-head").removeClass('active');
    $('.acc-content').slideUp();
   $(this).hide();
   $(".brand-logos ul").find("li").show();
  });
});

$(document).on('click','[data-dynamic-variants-enabled] .sizeoption li',function(){
  $(this).siblings('li').removeClass('active');
  $(this).closest('.product-block').find('[data-dynamic-variants-enabled] .sizeoption li').removeClass('active');
  $(this).addClass('active');

  $(this).closest('.variant-wrapper').find('.variant__button-label .uk').hide();
  $(this).closest('.variant-wrapper').find('.variant__button-label .us').hide();
  $(this).closest('.variant-wrapper').find('.variant__button-label .eu').hide();
  
  if($(this).hasClass('uk')){
    $(this).closest('.variant-wrapper').find('.variant__button-label .uk').show();
  } else if($(this).hasClass('us')){
    $(this).closest('.variant-wrapper').find('.variant__button-label .us').show();
  } else if($(this).hasClass('eu')){
    $(this).closest('.variant-wrapper').find('.variant__button-label .eu').show();
  }
});

$(document).on('click','.dropdown-menu .sizeoption li',function(){
// $('.dropdown-menu .sizeoption li').click(function(){
  $('.dropdown-menu .sizeoption li').removeClass('active');
  $(this).addClass('active');

  $(this).closest('.dropdown-menu').find('span1.uk').hide();
  $(this).closest('.dropdown-menu').find('span1.us').hide();
  $(this).closest('.dropdown-menu').find('span1.eu').hide();
  
  if($(this).hasClass('uk')){
    $(this).closest('.dropdown-menu').find('span1.uk').show();
  } else if($(this).hasClass('us')){
    $(this).closest('.dropdown-menu').find('span1.us').show();
  } else if($(this).hasClass('eu')){
    $(this).closest('.dropdown-menu').find('span1.eu').show();
  }
});


  